import { useState } from 'react';
import { MdMoreHoriz, MdOutlineCurrencyExchange } from 'react-icons/md';
import { FaUserMinus } from 'react-icons/fa';

import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import { useGetMe } from 'legacy/user/hooks';
import ConfirmRevokeStep from '../ConfirmRevokeStep';
import { StepsIds } from '../../types';
import { UserTicketDto } from '../../../../types';
import TransferredOptions from '../TransferredOptions';
import DefaultOptions from '../DefaultOptions';
import RequestRefundStep from '../RequestRefundStep';

type Props = {
  ticket: UserTicketDto;
  onClose: () => void;
  refetchTickets: () => void;
};

const STEPS = {
  [StepsIds.DefaultOptions]: {
    Icon: MdMoreHoriz,
    title: 'More Actions',
    Component: DefaultOptions
  },
  [StepsIds.TransferredOptions]: {
    Icon: MdMoreHoriz,
    title: 'More Actions',
    Component: TransferredOptions
  },
  [StepsIds.ConfirmRevokeStep]: {
    Icon: FaUserMinus,
    title: 'Revoke Ticket',
    Component: ConfirmRevokeStep
  },
  [StepsIds.RequestRefundStep]: {
    Icon: MdOutlineCurrencyExchange,
    title: 'Request A Refund',
    Component: RequestRefundStep
  }
};

const OptionsModal = ({ ticket, onClose, refetchTickets }: Props) => {
  const { data: user } = useGetMe();
  const isTransfer =
    ticket.owner.id === user._id && ticket.holder.id !== user._id;

  const [currentStepId, setCurrentStepId] = useState(
    isTransfer ? StepsIds.TransferredOptions : StepsIds.DefaultOptions
  );

  const goToStep = (stepId: StepsIds) => {
    setCurrentStepId(stepId);
  };

  const modalContent = STEPS[currentStepId];

  return (
    <Modal
      visible
      onClose={onClose}
      type={ModalType.SMALL}
      title={modalContent.title}
      icon={<modalContent.Icon size={20} />}
      autoHeight
    >
      <modalContent.Component
        goToStep={goToStep}
        ticket={ticket}
        onClose={onClose}
        refetchTickets={refetchTickets}
      />
    </Modal>
  );
};

export default OptionsModal;
